<template>
  <div class="payout-detail-modal">
    <el-dialog :title="$t('data.bill_details')" :visible.sync="dialogTableVisible" width="780px" class="diglog-card" @open="getDetailInfo">
      <div class="header-line" />
      <div class="total">
        <div class="total-item">
          <div class="total-title">{{ $t('customerService.bill_amount') }}:</div>
          <div class="total-num"> {{ $store.getters.currency }}  {{ merchantInfo.total_amount | toDivideWithDot }}</div>
        </div>
        <div class="line" />
        <div class="total-item">
          <div class="total-title">{{ $t('customerService.principal_repayment_amount') }}:</div>
          <div class="total-num"> {{ $store.getters.currency }}  {{ merchantInfo.total_principal_amount | toDivideWithDot }}</div>
        </div>
        <div class="line" />
        <div class="total-item">
          <div class="total-title">{{ $t('customerService.interest') }}:</div>
          <div class="total-num"> {{ $store.getters.currency }}  {{ merchantInfo.total_interest_amount | toDivideWithDot }}</div>
        </div>
        <div class="line" />
        <div class="total-item">
          <div class="total-title">{{ $t('customerService.penalty_repayment_amount') }}:</div>
          <div class="total-num"> {{ $store.getters.currency }}  {{ merchantInfo.total_penalty_amount | toDivideWithDot }}</div>
        </div>
      </div>

      <div class="section-title">
        {{ $t('data.timeline') }}
      </div>
      <div class="line-bottom-1px" />

      <div class="item">
        <span class="item-left content-blue">{{ $t('data.payout_created') }}</span>
        <span class="content-blue">{{ $t('data.payout_completed') }}</span>
      </div>

      <div class="item">
        <span class="item-left" style="color: #4B5567">{{ merchantInfo.create_time }}</span>
        <span class="content-gray">{{ merchantInfo.complete_time }}</span>
      </div>

      <div class="section-title">
        {{ $t('data.description') }}
      </div>
      <div class="line-bottom-1px" />
      <div class="tableContainer">
        <el-table :data="merchantInfo.installment_plan_items" style="width: 100%">
          <!-- 期数 -->
          <el-table-column prop="period" :label="$t('customerService.installment_term')" align="center" />
          <!-- 还款日 -->
          <el-table-column prop="repayment_date" :label="$t('customerService.due_date')" align="center">
            <template slot-scope="{row}">
              <span>{{ row.repayment_date }}</span>
            </template>
          </el-table-column>
          <!-- 金额 -->
          <el-table-column prop="overdue_principal_amount" :label="$t('merchantAccount.amount')" align="center">
            <template slot-scope="{row}">
              <span>{{ row.total_amount | toDivideWithDot }}</span>
            </template>
          </el-table-column>
          <!-- 本金 -->
          <el-table-column prop="principal_amount" :label="$t('customerService.principal_repayment_amount')" align="center" >
            <template slot-scope="{row}">
              <span>{{ row.principal_amount | toDivideWithDot }}</span>
            </template>
          </el-table-column>
          <!-- 利息 -->
          <el-table-column prop="interest_amount" :label="$t('customerService.interest')" align="center">
            <template slot-scope="{row}">
              <span>{{ row.interest_amount | toDivideWithDot }}</span>
            </template>
          </el-table-column>
          <!-- 罚金 -->
          <el-table-column prop="penalty_amount" :label="$t('customerService.penalty_repayment_amount')" align="center">
            <template slot-scope="{row}">
              <span>{{ row.penalty_amount | toDivideWithDot }}</span>
            </template>
          </el-table-column>
          <!-- 状态 -->
          <el-table-column prop="total_amount" :label="$t('components.status')" align="center">
            <template slot-scope="{row}">
              <span>{{ getPaymentStatusMap(row.status).label }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <el-tag :type="getBillStatusMap(merchantInfo.status).type" min-width="150" class="payout-status tag-custom"> {{ getBillStatusMap(merchantInfo.status).label }}</el-tag>
    </el-dialog>
  </div>
</template>

<script>
import { billStatusMap, loanStatusMap, paymentStatusMap } from '@/maps/status'
import { getCreditLoanOrderDetail } from '@/api/settlement/settlement'
export default {
  name: 'Loan_Bill_Details_Modal',
  components: {
  },
  props: {
    detailId: {
      type: String,
      default: '0'
    }
  },
  data() {
    return {
      dialogTableVisible: false, // 控制弹框显示隐藏
      listLoading: false,
      merchantInfo: {} // 用户基本信息
    }
  },
  computed: {
    getLoanStatusMap() {
      return function(value) {
        return loanStatusMap(value)
      }
    },
    getBillStatusMap() {
      return function(value) {
        return billStatusMap(value)
      }
    },
    getPaymentStatusMap() {
      return function(value) {
        return paymentStatusMap(value)
      }
    }
  },
  mounted() {
  },
  methods: {
    getDetailInfo() {
      this.merchantInfo = {}
      const params = { transaction_id: this.detailId }
      getCreditLoanOrderDetail(params).then(res => {
        this.merchantInfo = res.data
      })
    },
    // 改变弹框状态
    changModalStatus(value) {
      this.dialogTableVisible = value
      this.getDetailInfo()
    },

    onClickCancal() {
      this.changModalStatus(false)
    }
  }
}
</script>
<style>
.payout-detail-modal .el-dialog__title {
  font-weight: 500;  font-family: 'Inter-Medium';
  font-size: 16px;
  color: #000000;
}
.payout-detail-modal .header-line{
  margin: -26px 0 0;
  border-bottom: 1px solid #D3D7DF;
}
</style>
<style scoped lang="scss">
.total{
  display: inline-flex;
  justify-content: space-between;
  margin-top: 18px;
  width: 100%;

  .line{
    display: inline-block;
    content:'';
    height: 52px;
    width: 1px;
    background: #D3D7DF;
  }
  &-title{
    font-size: 14px;
    line-height: 17px;
    color: #606266;
  }
  &-num{
    margin-top: 12px;
    font-size: 22px;
    font-family: Source Han Sans SC;
    font-weight: 600;  font-family: 'Inter-SemiBold';
    line-height: 1.2;
    color: #3855F1;
  }
}
.item{
  display: flex;
  margin-top: 16px;
  .item-left{
    display: inline-block;
    width: 250px;
  }
}

.content-blue{
  font-weight: 500;  font-family: 'Inter-Medium';
  font-size: 14px;
  line-height: 17px;
  background: linear-gradient(180deg, #488CE8 0%, #0058CF 100%);
background-clip: text;
-webkit-background-clip: text;
-webkit-text-fill-color: transparent;;
}
.content-gray{
  flex: 1;
  font-weight: 500;  font-family: 'Inter-Medium';
  font-size: 14px;
  line-height: 15px;
  color: #4B5567;
}

.payout-detail-modal{
  .payout-status{
    text-align: center;
    position: absolute;
    top: 20px;
    left: 160px;
  }
}
</style>
